// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmExitReportInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/confirm_exit_report
 *
 * Confirm an exit report (requires 5 photos).
 */
import { registerContract } from './validate'

export interface Orders_ConfirmExitReportInput {
order_item_id: number
observations?: string
final_status?: string
}

registerContract('Orders_ConfirmExitReportInput', {
  order_item_id: { type: 'number',  required: true },
  observations:  { type: 'string',  required: false },
  final_status:  { type: 'string',  required: false },
})
